import type { Tag, Workspace } from '@carboncopyco/types';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useFolderManageAccess } from './FolderManageAccessContext';

export const FolderManageAccessListRowWrapper = ({
  item,
  children,
}: {
  item: Workspace | Tag;
  children: ReactNode;
}) => {
  const { selectedWorkspaces, selectedTags } = useFolderManageAccess();

  const onToggle = () => {
    if (selectedWorkspaces.has(item.id)) {
      return selectedWorkspaces.delete(item.id);
    }
    if (selectedTags.has(item.id)) {
      return selectedTags.delete(item.id);
    }

    item['name'] ? selectedTags.add(item.id) : selectedWorkspaces.add(item.id);
  };

  return (
    <div
      onClick={onToggle}
      className={classNames(
        'py-2 px-3 rounded-md mb-1 pointer',
        selectedTags.has(item.id) || selectedWorkspaces.has(item.id)
          ? 'bg-ds-primary-50'
          : 'hover:bg-ds-natural-50'
      )}
    >
      {children}
    </div>
  );
};
